import { INITIALIZE_VALUES } from '../actionTypes';
import { loadAndWindModalActons } from '../reducer';

export default (values) => loadAndWindModalActons[INITIALIZE_VALUES](values);
